import { OptionSelectFormProps } from './OptionSelectForm';

// UTI OPTIONS

export const UTI_QUESTION_1: OptionSelectFormProps = {
  title: 'What are your current symptoms?',
  eyebrow: 'Next up...',
  tooltip: 'Select all that apply',
  questionType: 'multiSelect',
  optionType: 'titleOnly',
  options: [
    {
      title: 'None of these',
      isSelected: false,
      isIneligible: true,
      isExclusive: true,
    },
    {
      title: 'Urinary urgency',
      isSelected: false,
      isIneligible: false,
      isExclusive: false,
    },
    {
      title: 'Urinary frequency',
      isSelected: false,
      isIneligible: false,
      isExclusive: false,
    },
    {
      title: 'Painful urination',
      isSelected: false,
      isIneligible: false,
      isExclusive: false,
    },
    {
      title: 'Mild abdominal or pelvic pain',
      isSelected: false,
      isIneligible: false,
      isExclusive: false,
    },
    {
      title: 'Mild fatigue',
      isSelected: false,
      isIneligible: false,
      isExclusive: false,
    },
    {
      title: 'Cloudy urine',
      isSelected: false,
      isIneligible: false,
      isExclusive: false,
    },
    {
      title: 'Urinary odor',
      isSelected: false,
      isIneligible: false,
      isExclusive: false,
    },
  ],
};

export const UTI_QUESTION_2: OptionSelectFormProps = {
  title: 'Do you experience any of the following:',
  eyebrow: 'Tell us more...',
  tooltip: 'Select all that apply',
  questionType: 'multiSelect',
  optionType: 'titleAndDescription',
  options: [
    {
      title: 'Visibly bloody urine',
      isSelected: false,
      isIneligible: false,
      isExclusive: false,
    },
    {
      title: 'Chills or fever at or above 100.4°F',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title: 'Significant fatigue or feeling ill',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title: 'Flank pain',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title: 'Moderate to severe abdominal or pelvic pain',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title: 'Vaginal symptoms (pruritus or discharge)',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title: 'Unintentional weight loss',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title: 'Night sweats',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title: 'None of these',
      isSelected: false,
      isIneligible: false,
      isExclusive: true,
    },
  ],
};

export const UTI_QUESTION_3: OptionSelectFormProps = {
  title: 'Do any of these things apply to you?',
  eyebrow: 'One last thing...',
  tooltip: 'Select all that apply',
  questionType: 'multiSelect',
  optionType: 'titleAndDescription',
  options: [
    {
      title:
        'Have had more than 2 UTIs in the last six months or 3 or more in one year',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title: 'History of drug-resistant urinary tract infection',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title: 'History of urinary tract procedure or instrumentation',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title: 'Underlying urologic abnormality (e.g. stricture)',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title: 'Current known or suspected pregnancy',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title: 'Breastfeeding or bottle-feeding with breastmilk',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title:
        'Immunocompromised state (e.g. HIV or chemotherapy), or chronic/ongoing oral/injectable steroid use',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title:
        'Diabetes with a glucose level above 250 or hemoglobin A1c level ≥ 9%',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title: 'Hospitalization within the past 1 month',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title: 'Liver disease',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title: 'Kidney disease',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title: 'None of these',
      isSelected: false,
      isIneligible: false,
      isExclusive: true,
    },
  ],
};

export const utiQuestions = [UTI_QUESTION_1, UTI_QUESTION_2, UTI_QUESTION_3];

// BV AND YI OPTIONS

export const BV_AND_YI_QUESTION_1: OptionSelectFormProps = {
  eyebrow: 'Tell us more...',
  title: 'Do you experience any of the following:',
  tooltip: 'Select all that apply',
  questionType: 'multiSelect',
  optionType: 'titleAndDescription',
  options: [
    {
      title: 'Abdominal pain',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title: 'Fever above 100.4°F',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title:
        'Burning with urination, urinary frequency, urinary urgency, or bloody urine',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title: 'Pain with sexual intercourse',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title: 'Recent episode of unprotected sexual intercourse',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title:
        'Current or recent retained foreign body in the vagina (e.g. tampon or condom)',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title:
        'Current or recent warts, lesions, or bumps on or around the vagina',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title: 'Concern about a possible sexually transmitted infection',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title: 'None of these',
      isSelected: false,
      isIneligible: false,
      isExclusive: true,
    },
  ],
};

export const BV_AND_YI_QUESTION_2: OptionSelectFormProps = {
  eyebrow: 'One last thing...',
  title: 'Do any of these things apply to you?',
  tooltip: 'Select all that apply',
  questionType: 'multiSelect',
  optionType: 'titleAndDescription',
  options: [
    {
      title: 'Current known or suspected pregnancy',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title: 'Breastfeeding or bottle-feeding with breastmilk',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title:
        'Current symptoms of bacterial vaginosis or yeast infection that did not clear up with prior prescription treatment',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title:
        'Heart disease, such as heart attack, congestive heart failure, or heart rhythm problems',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title:
        'Diabetes with a glucose level above 250 or hemoglobin A1c level ≥ 9%',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title: 'History of gynecologic surgery or Crohn’s disease',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title: 'Liver disease',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title: 'Kidney disease',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title: 'None of these',
      isSelected: false,
      isIneligible: false,
      isExclusive: true,
    },
  ],
};

export const bvAndYiQuestions = [BV_AND_YI_QUESTION_1, BV_AND_YI_QUESTION_2];

// GH OPTIONS

export const GH_QUESTION_1: OptionSelectFormProps = {
  eyebrow: 'Next up...',
  title: 'Is this your first genital herpes outbreak?',
  questionType: 'singleSelect',
  optionType: 'titleOnly',
  options: [
    {
      title: 'Yes',
      isSelected: false,
      isIneligible: true,
      isExclusive: true,
    },
    {
      title: 'No',
      isSelected: false,
      isIneligible: false,
      isExclusive: true,
    },
  ],
};

export const GH_QUESTION_2: OptionSelectFormProps = {
  eyebrow: 'Tell us more...',
  title: 'Where are your current symptoms?',
  tooltip: 'Select all that apply',
  questionType: 'multiSelect',
  optionType: 'titleOnly',
  options: [
    {
      title: 'Genitals',
      isSelected: false,
      isIneligible: false,
      isExclusive: false,
    },
    {
      title: 'Buttocks',
      isSelected: false,
      isIneligible: false,
      isExclusive: false,
    },
    {
      title: 'Inner thighs',
      isSelected: false,
      isIneligible: false,
      isExclusive: false,
    },
    {
      title: 'Other',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
  ],
};

export const GH_QUESTION_3: OptionSelectFormProps = {
  eyebrow: 'Tell us more...',
  title: 'How long have you had your current outbreak?',
  questionType: 'singleSelect',
  optionType: 'titleOnly',
  options: [
    {
      title: '1-2 days',
      isSelected: false,
      isIneligible: false,
      isExclusive: false,
    },
    {
      title: '3-7 days',
      isSelected: false,
      isIneligible: false,
      isExclusive: false,
    },
    {
      title: '8-20 days',
      isSelected: false,
      isIneligible: false,
      isExclusive: false,
    },
    {
      title: 'Over 20 days',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title: 'I don’t currently have an outbreak',
      isSelected: false,
      isIneligible: false,
      isExclusive: false,
    },
  ],
};

export const GH_QUESTION_4: OptionSelectFormProps = {
  eyebrow: 'Tell us more...',
  title: 'How severe is your current or typical outbreak?',
  questionType: 'singleSelect',
  optionType: 'titleOnly',
  options: [
    {
      title: 'Mild (1 cluster)',
      isSelected: false,
      isIneligible: false,
      isExclusive: false,
    },
    {
      title: 'Moderate (2-3 clusters)',
      isSelected: false,
      isIneligible: false,
      isExclusive: false,
    },
    {
      title: 'Severe (more than 3 or widespread)',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
  ],
};

export const GH_QUESTION_5: OptionSelectFormProps = {
  eyebrow: 'One last thing...',
  title: 'Do any of these things apply to you?',
  tooltip: 'Select all that apply',
  questionType: 'multiSelect',
  optionType: 'titleAndDescription',
  options: [
    {
      title: 'Current known or suspected pregnancy',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title: 'Breastfeeding or bottle-feeding with breastmilk',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title: 'Fever > 100.4°F',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title: 'Chills, body aches, or swollen lymph nodes',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title: 'Diagnosis of HIV',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title: 'Seizures or diagnosis of epilepsy',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title: 'Kidney disease',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title: 'Abnormal blood counts',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title: 'Any medication or condition that suppresses your immune system',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title:
        'Mental health conditions (includes psychosis, delirium, or aggression)',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title: 'None of these',
      isSelected: false,
      isIneligible: false,
      isExclusive: true,
    },
  ],
};

export const ghQuestions = [
  GH_QUESTION_1,
  GH_QUESTION_2,
  GH_QUESTION_3,
  GH_QUESTION_4,
  GH_QUESTION_5,
];

// CS OPTIONS

export const CS_QUESTION_1: OptionSelectFormProps = {
  eyebrow: 'Next up...',
  title: 'How long have you had your current outbreak?',
  questionType: 'singleSelect',
  optionType: 'titleOnly',
  options: [
    {
      title: '1-2 days',
      isSelected: false,
      isIneligible: false,
      isExclusive: false,
    },
    {
      title: '3-7 days',
      isSelected: false,
      isIneligible: false,
      isExclusive: false,
    },
    {
      title: '8-20 days',
      isSelected: false,
      isIneligible: false,
      isExclusive: false,
    },
    {
      title: 'Over 20 days',
      isSelected: false,
      isIneligible: true,
      isExclusive: false,
    },
    {
      title: 'I don’t currently have an outbreak',
      isSelected: false,
      isIneligible: false,
      isExclusive: false,
    },
  ],
};

export const CS_QUESTION_2 = GH_QUESTION_4;

export const CS_QUESTION_3 = GH_QUESTION_5;

export const csQuestions = [CS_QUESTION_1, CS_QUESTION_2, CS_QUESTION_3];
